<template>
  <div
    class="container_pwa"
    v-if="shown && domain === 'central.global-fibra.com'"
  >
    Instalar aplicativo?

    <button @click="installPWA">Sim</button>

    <button class="dismiss_pwa" @click="dismissPrompt">Não</button>
  </div>
</template>

<script>
export default {
  data: () => ({
    shown: false
  }),

  computed: {
    domain() {
      return window.location.hostname;
    }
  },

  beforeMount() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      this.installEvent = e;
      this.shown = true;
    });
  },

  methods: {
    dismissPrompt() {
      this.shown = false;
    },

    installPWA() {
      this.installEvent.prompt();
      this.installEvent.userChoice.then(choice => {
        this.dismissPrompt(); // Hide the prompt once the user's clicked
        if (choice.outcome === "accepted") {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
.container_pwa {
  font-weight: bold;
  margin: 15px;
}
.container_pwa button.dismiss_pwa {
  background-color: #ea4844;
  margin-left: 10px;
}

@media (min-width: 768px) {
  .container_pwa {
    display: none;
  }
}
</style>
